import store from "@/store";

const funeralAuth = (to, from, next) => {
  if (!store.getters.isFuneralAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/funeral/loginDo");
  } else {
    next();
  }
};
const corpAuth = (to, from, next) => {
  if (!store.getters.isCorpAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/corp/loginDo");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "SkinBanner"
    },
    path: "/funeral/skinBanner",
    name: "SkinBanner",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/SkinBanner.vue")
  },
  {
    meta: {
      title: "SkinBanner"
    },
    path: "/corp/skinBanner",
    name: "SkinBanner",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/SkinBanner.vue")
  }
];
